/* eslint-disable react/prop-types */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { scrollToTop } from '../components/common/Helpers/index';

// eslint-disable-next-line import/no-extraneous-dependencies
// import { withRouter } from 'react-router-dom';

/**
 * Helper that facilitate the use of the {@link Route} component
 */

/**
 * Returns a composite component where a {@link Route} component wraps the provided component
 *
 * @param {React.Component} WrappedComponent    - React component to be wrapped
 * @param {string} [extension=html]             - extension used to identify a route amongst the tree of resource URLs
 * @returns {CompositeRoute}
 */
export const withRoute = (WrappedComponent, extension) =>
  class CompositeRoute extends Component {
    render() {
      const routePath = this.props.cqPath;
      if (!routePath) {
        return <WrappedComponent {...this.props} />;
      }
      extension = extension || 'html';
      return (
        <Route key={routePath} path={`(.*)${routePath}.${extension}`} render={(routeProps) => <WrappedComponent {...this.props} {...routeProps} />} />
      );
    }
  };

/**
 * ScrollToTop component will scroll the window on every navigation.
 * wrapped in in `withRouter` to have access to router's props.
 */
class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      scrollToTop();
    }
  }

  render() {
    return this.props.children;
  }
}
export default withRouter(ScrollToTop);
